import axios, { AxiosRequestConfig } from "axios";
import axiosRetry from "axios-retry";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";
import { logError } from "utils/logger";

export type GetFinanceExampleSidePanelParams = {
    vehicleId: number;
};

export type GetFinanceExampleSidePanelResponse = {
    VehicleAdvertUri: string;
    VehicleTitle: string;
    VehicleDescription: string;
    LegalDisclaimer: string;
    VehicleId: number;
    Title: string;
    Description: string;
    MonthlyPaymentTitle: string;
    MonthlyPaymentText: string;
    InterestRateTitle: string;
    InterestRateText: string;
    TotalAmountTitle: string;
    TotalAmountText: string;
    CostOfCreditTitle: string;
    CostOfCreditText: string;
    OptionalFinalPaymentTitle: string;
    OptionalFinalPaymentText: string;
    PurchaseFeeTitle: string;
    PurchaseFeeText: string;
    AnnualMileageTitle: string;
    AnnualMileageText: string;
};

export const getFinanceExampleSidePanel = async (params: GetFinanceExampleSidePanelParams) => {
    const axiosConfig: AxiosRequestConfig = {
        headers: {
            "Content-Type": "application/json",
            Accept: "/",
            "Cache-Control": "no-cache",
        },
        withCredentials: true,
    };

    const baseUrl = `${process.env.NEXT_PUBLIC_BASE_FINANCE_EXAMPLE_ENDPOINT}/getfinanceexamplesidepanel/${params.vehicleId}`;

    try {
        axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

        const response = await axios.get<GetFinanceExampleSidePanelResponse>(baseUrl, axiosConfig);

        axiosOnSuccessEvent(response);

        return response.data;
    } catch (e) {
        const error = e as { message: string; msg: string };
        logError(
            "Error from get finance example side panel request (getFinanceExampleSidePanel)",
            error.msg
        );
        return undefined;
    }
};
